export class CsiteFront {
    id: number;
    name: string;
    dateQty: number;
    noDateQty: number;
    total: number;
    date30Qty: number;
    noDate30Qty: number;
    postsaleManager: string;
    postsaleTechnician: string;
}
